import { Controller, useFormContext } from "react-hook-form";
import { t } from "@/i18n-js/instance";
import { RadioButtonGroup } from "@circle-react-shared/RadioButtonGroup";
import { Typography } from "@circle-react-shared/uikit/Typography";
import { UPSELL_LOCALE_ROOT } from "../../constants";
import { Label } from "./Label";

export const UpsellForm = () => {
  const { control } = useFormContext();

  return (
    <div className="flex flex-col gap-y-6">
      <Typography.TitleXl>
        {t([UPSELL_LOCALE_ROOT, "title"])}
      </Typography.TitleXl>
      <Typography.BodySm>
        {t([UPSELL_LOCALE_ROOT, "description"])}
      </Typography.BodySm>
      <Controller
        control={control}
        name="paywall_offers_attributes.offer_type"
        render={({ field: { onChange, value, name } }) => (
          <RadioButtonGroup
            name={name}
            onChange={onChange}
            defaultChecked={value}
            shouldShowInlineOptions
            hasCheckedIcon={false}
            options={[
              {
                label: (
                  <Label
                    title={t([
                      UPSELL_LOCALE_ROOT,
                      "forms.upsell.options.addon.title",
                    ])}
                  />
                ),
                value: "addon",
                icon: "16-add-to-basket",
                iconSize: 16,
                disabled: false,
              },
              {
                label: (
                  <Label
                    title={t([
                      UPSELL_LOCALE_ROOT,
                      "forms.upsell.options.upgrade.title",
                    ])}
                    disabled
                    badgeText={t([
                      UPSELL_LOCALE_ROOT,
                      "forms.upsell.options.upgrade.badge",
                    ])}
                    badgeTooltip={t([
                      UPSELL_LOCALE_ROOT,
                      "forms.upsell.options.upgrade.tooltip",
                    ])}
                  />
                ),
                value: "upgrade",
                icon: "20-trends",
                iconSize: 20,
                disabled: true,
              },
            ]}
          />
        )}
      />
    </div>
  );
};
